export default __webpack_public_path__ + "static/lutein-table-xl-en-ab897f94eec71e359cba0ecb9bcab48d.svg";